import { Dispatch, SetStateAction } from 'react';
import { editCoctail } from '../../../store/coctailsSlice';
import styles from './AddingImages.module.scss';
import { useAppDispatch } from '../../../store/hooks';
import { ICoctail, TActions } from '../../../types';
import { message } from 'antd';
import { Upload } from '../../form/Upload';

interface AddingImagesProps {
  action: TActions;
  coctail?: ICoctail;
  setCoctail: Dispatch<SetStateAction<ICoctail>>;
  onToggleDisabled?: (value: boolean) => void;
}

const AddingImages = ({ coctail, action, setCoctail, onToggleDisabled }: AddingImagesProps) => {
  const dispatch = useAppDispatch();

  const onUpdateImageCoctail = async (name: string | null) => {
    onToggleDisabled?.(true);
    setCoctail(prev => ({
      ...prev,
      eng: { ...prev.eng, media: { ...prev?.eng?.media, posterName: name } },
    }));
    if (action === 'edit') {
      await dispatch(
        editCoctail({
          coctail: {
            ...coctail,
            eng: { ...coctail.eng, media: { ...coctail?.eng?.media, posterName: name } },
          },
          id: coctail._id,
        }),
      );
      message.success('Images updated successfully!');
      onToggleDisabled?.(false);
    }
  };

  return (
    <div className={styles.upload}>
      <Upload
        type="image"
        withDeleteButton
        value={coctail?.eng?.media?.posterName || null}
        setValue={onUpdateImageCoctail}
        onToggleDisabled={onToggleDisabled}
      />
    </div>
  );
};

export default AddingImages;
